import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToTop.vue?vue&type=style&index=0&id=7e2688f0&lang=css"

const __exports__ = script;

export default __exports__